import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgTemplateAssertTypeModule } from '@recruitee/common';

import { RtUICoreOverlayModule } from './../../core/core.module';
import { TypeaheadInlineComponent } from './typeahead-inline.component';
import { TypeaheadInputDirective } from './typeahead-input.directive';
import { TypeaheadSuggestionsComponent } from './typeahead-suggestions.component';
import { TypeaheadComponent } from './typeahead.component';

@NgModule({
  exports: [
    TypeaheadComponent,
    TypeaheadInlineComponent,
    TypeaheadInputDirective,
    TypeaheadSuggestionsComponent,
  ],
  imports: [
    RtUICoreOverlayModule,
    CommonModule,
    NgTemplateAssertTypeModule,
    TypeaheadComponent,
    TypeaheadInlineComponent,
    TypeaheadInputDirective,
    TypeaheadSuggestionsComponent,
  ],
})
export class TypeaheadModule {}

export {
  TypeaheadInlineComponent,
  TypeaheadComponent,
  TypeaheadInputDirective,
  TypeaheadSuggestionsComponent,
};
export { SuggestionsContext } from './typeahead.component';
export { SuggestionsTemplateContext } from './typeahead-inline.component';
export { SuggestionItemContext } from './typeahead-suggestions.component';
